import { courseColor, drawnCourses } from '@/components/map/course-map/courses'
import type { Race } from '@/lib/athletes/types'

export interface RaceLook {
  /** Short, as the map's legend says it: "42 km". */
  label: string
  name: string
  color: string
}

/** Each race as the event map draws it: the legend's short label and the course colour its athletes' dots take. */
export function raceLooks(races: readonly Race[]): Map<string, RaceLook> {
  const drawn = drawnCourses(races)
  if (!drawn) return new Map(races.map((race) => [race.id, { label: race.name, name: race.name, color: courseColor(0) }]))
  return new Map(drawn.map((course) => [String(course.route.id), { label: course.label, name: course.name, color: course.color }]))
}

/** A race as a swatch of its course colour and its short label, the full name on hover. */
export function RaceLabel({ look }: { look: RaceLook | undefined }) {
  if (!look) return <>—</>
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap" title={look.name}>
      <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: look.color, boxShadow: '0 0 0 1px var(--play-ink)' }} aria-hidden="true" />
      {look.label}
    </span>
  )
}
